import React, { Suspense, lazy } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  RouterProvider,
} from "react-router-dom";
//pages
// Home is imported eagerly since it's the most common landing page —
// no need to pay a lazy-load round trip for the first thing most visitors see.
import Home from "./pages/Home";
// Everything else is code-split: each page's JS (and any data it pulls in,
// like coursesData.js) is only downloaded when a visitor actually navigates there.
const About = lazy(() => import("./pages/about/About"));
const Contact = lazy(() => import("./pages/contact/Contact"));
const Placements = lazy(() => import("./pages/courses/Placements"));
const FAQ = lazy(() => import("./pages/FAQ"));
const PrivacyPolicy = lazy(() => import("./pages/PrivacyPolicy"));
const TermsCondition = lazy(() => import("./pages/TermsCondition"));
const Services = lazy(() => import("./pages/services/index"));
const ServicesPage = lazy(() => import("./pages/services/ServicesPage"));
const Courses = lazy(() => import("./pages/courses/index"));
const CoursePage = lazy(() => import("./pages/courses/CoursePage"));
const ModulePage = lazy(() => import("./pages/courses/ModulePage"));
const Products = lazy(() => import("./pages/products/ProductsIndexLayout"));
const AdminDashboard = lazy(() => import("./pages/admin/AdminDashboard"));

// NOTE: ProductDetailPage.js is no longer used — ProductsIndexLayout.js now
// handles both the "/products" listing view and the "/products/:slug" detail
// view internally (it reads the slug via useParams()). Both routes below
// point at the same lazy-loaded Products component.
// Small fallback shown while a lazy page chunk is downloading.
const PageLoader = () => (
  <div
    style={{
      minHeight: "60vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontSize: "16px",
      color: "#6b7280",
    }}
  >
    Loading...
  </div>
);
// Wraps a lazy element in Suspense so React shows the fallback
// instead of throwing while the chunk loads.
const withSuspense = (element) => (
  <Suspense fallback={<PageLoader />}>{element}</Suspense>
);
const router = createBrowserRouter(
  createRoutesFromElements(
    <>
      <Route path="/admin" element={withSuspense(<AdminDashboard />)} />
      <Route path="/" element={<App />}>
        <Route index  element={<Home />} />
        <Route path="/about" element={withSuspense(<About />)} />
        <Route path="services" element={withSuspense(<Services />)} />
        <Route path="services/:servicesSlug" element={withSuspense(<ServicesPage />)} />
        <Route path="courses" element={withSuspense(<Courses />)} />
        <Route path="courses/:courseSlug" element={withSuspense(<CoursePage />)} />
        <Route path="courses/:courseSlug/modules/:moduleId" element={withSuspense(<ModulePage />)} />
        <Route path="products" element={withSuspense(<Products />)} />
        <Route path="products/:slug" element={withSuspense(<Products />)} />
        <Route path="careers" element={withSuspense(<Placements />)} />
        <Route path="faqs" element={withSuspense(<FAQ />)} /> 
        <Route path="PrivacyPolicy" element={withSuspense(<PrivacyPolicy />)} /> 
        <Route path="TermsCondition" element={withSuspense(<TermsCondition />)}/>
        <Route path="contact-us" element={withSuspense(<Contact />)} />
      </Route>
    </>
  )
);
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
     <RouterProvider router={router}/>
  </React.StrictMode>
);
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();